var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "c-alpha" }, [
    _c("div", {
      staticClass: "c-alpha-gradient",
      style: { background: _setup.gradientColor },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "containerRef",
        staticClass: "c-alpha-container",
        attrs: { role: "slider" },
        on: {
          click: _setup.handleChange,
          mousedown: _setup.handleMouseDown,
          touchmove: _setup.handleChange,
          touchstart: _setup.handleChange,
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "c-alpha-pointer",
            style: { left: _vm.colors.a * 100 + "%" },
          },
          [_c("div", { staticClass: "c-alpha-picker" })]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }